<template>
  <div>
    <v-container fluid>
      <v-card elevation="0" class="">
        <v-card-title class="ma-0 pa-0">
          <v-row justify="end" no-gutters class="ma-0">
            <v-col cols="12">
              <h3 class="my-2 mx-2 primary--text">
                {{ $t("settings.facility.title") }}
              </h3>
            </v-col>
            <!-- <v-spacer v-if="$vuetify.breakpoint.mdAndUp"></v-spacer> -->
            <v-col cols="4">
              <v-text-field
                :label="$t('common.search')"
                v-model="search"
                class="mx-2"
                :placeholder="$t('landlord.name')"
                outlined
                dense
              >
              </v-text-field>
            </v-col>
            <v-menu>
              <template #activator="{ on, attrs }">
                <v-btn class="ml-2" v-on="on" v-bind="attrs" icon>
                  <v-icon>mdi-menu</v-icon>
                </v-btn>
              </template>
              <v-list class="text-body-2">
                <v-list-item @click="showRightSideDrawer('FACILITY')">
                  <v-list-item-icon>
                    <v-icon color="primary"> mdi-plus-circle </v-icon>
                  </v-list-item-icon>
                  <v-list-item-text>
                    {{ $t("settings.facility.btnTitle") }}
                  </v-list-item-text>
                </v-list-item>
                <v-list-item @click="exportData">
                  <v-list-item-icon>
                    <v-icon color="success"> mdi-application-export </v-icon>
                  </v-list-item-icon>
                  <v-list-item-text>
                    {{ $t("common.excel") }}
                  </v-list-item-text>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-row>
        </v-card-title>
        <v-data-table
          :footer-props="{ 'items-per-page-options': [50, 100, 150, 200, -1] }"
          class="mt-2 datatable"
          :hide-default-footer="footer"
          :headers="headers"
          id="facilityTable"
          :items="facilityLists"
          :search="search"
          :loading="loading"
          mobile-breakpoint="0"
          :options.sync="options"
          :server-items-length="totalFacility"
        >
          <template v-slot:[`item._id`]="{ item }">
            <p class="my-0 py-0">
              {{
                options.page * options.itemsPerPage -
                  options.itemsPerPage +
                  facilityLists
                    .map(function(x) {
                      return x._id;
                    })
                    .indexOf(item._id) +
                  1
              }}
            </p>
          </template>
          <template v-slot:[`item.avatar`]="{ item }">
            <v-row class="mx-auto">
              <avatar
                v-if="item.avatar && !footer"
                class="mx-auto"
                :size="40"
                :src="`${$store.getters.imageBaseUrl}/${item.avatar}`"
              />
              <avatar
                v-else
                class="mx-auto"
                :username="item.nameEn"
                :size="40"
              />
            </v-row>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-row class="mx-auto" justify="center">
              <v-icon color="primary" class="mx-2" @click="editFacility(item)"
                >mdi-pencil</v-icon
              >
              <v-icon color="red" @click="showDeleteDialog(item)"
                >mdi-delete</v-icon
              >
            </v-row>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { deleteFacility } from "../methods/facility/delete_facility";
import avatar from "vue-avatar";
export default {
  data() {
    return {
      loading: false,
      footer: false,
      search: "",
      variables: {
        limit: 10,
        skip: 0
      },
      options: {
        itemsPerPage: 50,
        page: 1
      },
      facilityLists: [],
      totalFacility: 10
    };
  },
  components: {
    avatar
  },
  computed: {
    headers() {
      return [
        {
          text: "#",
          align: "left",
          value: "_id",
          sortable: false,
          width: 10
        },
        {
          text: `${this.$t("settings.area.name")} (${this.$t("common.en")})`,
          align: "left",
          value: "nameEn",
          sortable: false,
          width: 100
        },
        {
          text: `${this.$t("settings.area.name")} (${this.$t("common.ar")})`,
          align: "left",
          value: "nameAr",
          sortable: false,
          width: 100
        },
        {
          text: this.$t("landlord.avatar"),
          align: "center",
          value: "avatar",
          sortable: false,
          width: 100
        },
        {
          text: this.$t("common.actions"),
          value: "actions",
          align: "left",
          sortable: false,
          width: 100
        }
      ].map(header => {
        header.align = "center";
        return header;
      });
    }
  },
  watch: {
    search(val) {
      this.loading = true;
      this.$apollo.queries.getFacilities.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totalFacility,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        },
        filter: {
          searchKey: val
        }
      });
      this.loading = false;
    },
    options() {
      this.$apollo.queries.getFacilities.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totalFacility,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        },
        filter: {
          searchKey: this.search
        }
      });
    }
  },
  apollo: {
    getFacilities() {
      this.loading = true;
      return {
        query: require("@/settings/api/queries/facility/facility_query.graphql"),
        fetchPolicy: "no-cache",
        variables: {
          input: {
            limit: this.totalFacility,
            skip: 0
          },
          filter: {
            searchKey: this.search
          }
        },
        result({ data, loading }) {
          // , loading, networkStatus, refetch
          this.facilityLists = this.$format.cloneVariable(
            data.getFacilities.facilities
          );
          this.loading = loading;
          this.totalFacility = data.getFacilities.totalCount;
        }
      };
    }
  },
  mounted() {
    this.$root.$on("deleteItems", data => {
      if (data.module === "facility") {
        const input = data.item._id;
        deleteFacility(input).then(data => {
          if (data.data.deleteFacility) {
            this.$apollo.queries.getFacilities.refetch({
              input: {
                limit:
                  this.options.itemsPerPage !== -1
                    ? this.options.itemsPerPage
                    : this.totalFacility,
                skip:
                  this.options.page * this.options.itemsPerPage -
                  this.options.itemsPerPage
              },
              filter: {
                searchKey: ""
              }
            });
            this.$root.$emit("snackbar", {
              snackbar: true,
              text: this.$t("common.deleteSuccess"),
              color: "green"
            });
            this.$store.commit("DELETE_BTN_LOADING", false);
          }
        });
      }
    });
    this.$root.$on("facilityTable", () => {
      this.options.itemsPerPage = 50;
      this.$set(this.options, this.options.itemsPerPage, 50);
    });
    this.$root.$on("refetchFacility", () => {
      this.$apollo.queries.getFacilities.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totalFacility,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        },
        filter: {
          searchKey: ""
        }
      });
    });
    this.$root.$on("searchFacility", data => {
      this.search = data;
    });
    this.$root.$on("exportFacility", () => {
      this.exportData();
    });
  },
  methods: {
    showRightSideDrawer(item) {
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", true);
      this.$store.commit("APP_SETTINGS_FORMNAME", item);
    },
    exportData() {
      this.$apollo.queries.getFacilities
        .refetch({
          limit: 0,
          skip: 0
        })
        .then(data => {
          this.options.itemsPerPage = data.data.getFacilities.totalCount;
          this.facilityLists = data.data.getFacilities.facilities;
          this.footer = true;
          setTimeout(() => {
            this.htmlToExcel("facilityTable", "facility");
          }, 1000);
        });
    },
    showDeleteDialog(item) {
      this.$root.$emit("deleteDialog", {
        dialog: true,
        item: item,
        module: "facility"
      });
    },
    editFacility(item) {
      this.$store.commit("EDIT_FACILITY", item);
      this.$store.commit("IS_EDIT_FACILITY", true);
      this.$store.commit("APP_SETTINGS_FORMNAME", "FACILITY");
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", true);
    }
  },
  beforeDestroy() {
    this.$root.$off("facilityTable");
    this.$root.$off("deleteItems");
    this.$root.$off("refetchFacility");
    this.$root.$off("searchFacility");
    this.$root.$off("exportFacility");
  }
};
</script>
<style scoped>
.datatable >>> .v-data-footer__select {
  direction: ltr !important;
}
.datatable >>> .v-data-footer__pagination {
  direction: ltr !important;
}
</style>
